/* eslint-disable react/prop-types */
import React from 'react';
var SalesRepRow = function SalesRepRow(_ref) {
  var salesRepresentative = _ref.salesRepresentative;
  return /*#__PURE__*/React.createElement("div", null, salesRepresentative);
};
export default SalesRepRow;